export function getProvisionalScorePercentage(exercise: { score: { achieved: number; achievable: number } }) {
  const { achieved, achievable } = exercise.score;

  if (achievable === 0) return '0%';

  const percentage = Math.round((achieved / achievable) * 100);

  return `${percentage}%`;
}
